// @flow

import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { createStyleSheet } from 'jss-theme-reactor';
import Clear from '@catalytic/pushbot-ui/SvgIcon/Clear';

export const displayName = 'ModalSheetClose';

export const styleSheet = createStyleSheet(displayName, () => ({
  root: {
    width: '1.75em',
    height: '1.75em',
    color: 'black'
  },
  icon: {
    height: '100%',
    width: '100%'
  }
}));

export default class ModalSheetClose extends PureComponent<*> {
  static displayName = displayName;

  static contextTypes = {
    styleManager: PropTypes.object.isRequired
  };

  render() {
    const classes = this.context.styleManager.render(styleSheet);

    return (
      <Link {...this.props} className={classes.root}>
        <Clear className={classes.icon} />
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./js/ModalSheet/ModalSheetClose.js